import type { ServerSummary } from "@woven/contracts";
import { CapacityTooltip } from "../capacity/CapacityTooltip";
import { serverCapacity } from "./serverCapacity";

export function ServerCapacityMetric({ server }: { server: ServerSummary }) {
  const capacity = serverCapacity(server);
  return (
    <>
      <span>
        {capacity.allocatedCapacity === null
          ? "Not allocated"
          : `${capacity.allocatedCapacity.toLocaleString("en-US")} units`}
      </span>{" "}
      <CapacityTooltip tickRateHz={capacity.tickRateHz} ccu={server.allocatedCcu ?? 0} />
      <span className="capacity-secondary">
        {capacity.productType} · {capacity.tickRateHz} Hz · {server.allocatedCcu ?? "—"} CCU
        {capacity.legacy ? " · legacy defaults" : ""}
      </span>
      {capacity.pendingCapacity && (
        <span className="capacity-secondary">
          Requested: {capacity.pendingCapacity.productType} · {capacity.pendingCapacity.tickRateHz}{" "}
          Hz · {capacity.pendingCapacity.allocatedCcu} CCU ·{" "}
          {capacity.pendingCapacity.allocatedCapacity} units
        </span>
      )}
      {capacity.pending && (
        <span className="form-note">
          Capacity change pending; draining may retain reserved capacity. Existing connections are
          not promised to be disconnected.
        </span>
      )}
      {capacity.reservedCapacity !== null &&
        (capacity.pending || capacity.reservedCapacity !== capacity.allocatedCapacity) && (
          <span className="capacity-secondary">
            {capacity.reservedCapacity} units still reserved
          </span>
        )}
    </>
  );
}
